<template>
  <div id="Cardsales">
    <SimpleModal
      :title="'성공적으로 연동되었습니다.'"
      @close="complete"
      v-if="isShowSuccessModal"
    />
    <SimpleModal
      :title="messageFail"
      @close="isShowFailModal = false"
      v-if="isShowFailModal"
    />
    <CredentialForm
      :title="title"
      :description="description"
      :placeholderID="placeholderID"
      :placeholderPW="placeholderPW"
      :linkTitle="linkTitle"
      :link="link"
      :provider="provider"
      @success="success"
      @fail="fail"
    />
  </div>
</template>

<script>
import CredentialForm from '@/components/credential/Form'
import SimpleModal from '@/components/modal/SimpleModal'

export default {
  name: 'Cardsales',
  components: {
    CredentialForm,
    SimpleModal,
  },
  data: function () {
    return {
      title: '배달 매출 연동',
      description: '배달매출 파악을 위해\n 배달의 민족 사이트를 연동합니다.',
      placeholderID: '배민 사장님 광장 ID를 입력해주세요.',
      placeholderPW: '배민 사장님 광장 비밀번호를 입력해주세요.',
      linkTitle: '배민 사장님 광장 아이디 확인하기',
      link: 'https://ceo.baemin.com/',
      provider: 'baemin',
      isShowSuccessModal: false,
      isShowFailModal: false,
      messageFail: null,
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '배달 매출 연동')
  },
  methods: {
    success(data) {
      this.isShowSuccessModal = true
    },
    fail(data) {
      if (
        data &&
        data.non_field_errors &&
        data.non_field_errors[0] ===
          '필드 owner, provider 는 반드시 고유(unique)해야 합니다.'
      ) {
        this.messageFail = '이미 등록된 계정이 있습니다.'
      } else {
        this.messageFail = '로그인 실패했습니다.\n아이디 비번을 확인해주세요.'
      }
      this.isShowFailModal = true
    },
    complete() {
      this.isShowSuccessModal = false
      this.isShowFailModal = false
      this.$router.push({ name: 'dashboard' })
    },
  },
}
</script>

<style  scoped>
</style>
